import { ReactNode } from "react";
import { cn } from "../../lib/utils";
import NoResultDrawing from "../../assets/images/illustrations/search_no_results.svg";

export default function ErrorBlock({
  title,
  message,
  action = null,
}: {
  title: string;
  message: string;
  action?: ReactNode;
}) {
  // The action sits on the vertical center: the message fills the half above
  // it from the bottom, and an empty half of the same height lies below it.
  // Without an action, the message itself is centered.
  return (
    <div className="box-border p-[36px_22px] flex-1 flex flex-col items-center gap-4 bg-[#f7f8fc] text-center [&_button]:mt-2 [&_button]:w-fit">
      <div
        className={cn(
          // A 0px basis: a 0% one falls back to the content in this height-less column.
          "flex grow basis-0 flex-col items-center gap-4",
          action === null ? "justify-center" : "justify-end"
        )}
      >
        <img src={NoResultDrawing} alt="error" className="w-24" />
        <h1 className="m-0 text-2xl">{title}</h1>
        <p className="m-0 text-base">{message}</p>
      </div>
      {action}
      <div className={action === null ? "hidden" : "grow basis-0"} />
    </div>
  );
}
